import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
//注意：样式文件需要单独引入
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import {post, get, destroy, postByFormData} from './util/http'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
Vue.prototype.$post=post
Vue.prototype.$postByFormData=postByFormData
Vue.prototype.$get=get
Vue.prototype.$delete=destroy
import {getCookie,setCookie,delCookie}  from './util/common'
Vue.prototype.getCookie=getCookie;
Vue.prototype.setCookie=setCookie;
Vue.prototype.delCookie=delCookie;
//Vue.prototype.cookieDomain='localhost';
//Vue.prototype.cookieDomain='.quba360.com';
//Vue.prototype.baseURL='http://api.shenbipro.quba360.com';
Vue.prototype.cookieDomain='.shenbipro.com';
Vue.prototype.baseURL='https://api.shenbipro.com';
Vue.config.productionTip = false

import loading  from '../src/components/loading/loading'
Vue.use(loading)

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.matched.length ===0){
    from.name ? next({ name:from.name }) : next('/error');
  }
  let token = getCookie('token')

  // 保存上一页地址
  var d = new Date();
  d.setTime(d.getTime() + (1*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = "history=" + from.fullPath + "; " + expires+"; path=/;domain="+Vue.prototype.cookieDomain //path=/是根路径

  if(to.matched.some( m => m.meta.auth)){
    if(token) { // 已经登陆
      next()     // 正常跳转到你设置好的页面
    }else{
      next({path:'/login'})
    }
  }else{
    next()
  }
})
router.afterEach(( to, from, next ) => {
  setTimeout(()=>{
    // 此处粘贴百度统计复制过来的代码
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?3ace42263dea98157c3af5b32aebbe37";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  },0);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
